import React from "react";

function LoockIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87265 17.0998C4.07671 18.6155 5.33205 19.8028 6.8597 19.8731C8.14514 19.9321 9.45093 19.963 10.8889 19.963C12.3269 19.963 13.6326 19.9321 14.9181 19.8731C16.4458 19.8028 17.7011 18.6155 17.9052 17.0998C18.0384 16.1108 18.1482 15.0971 18.1482 14.0648C18.1482 13.0326 18.0384 12.0189 17.9052 11.0298C17.7011 9.51419 16.4458 8.32684 14.9181 8.2566C13.6326 8.19751 12.3269 8.16669 10.8889 8.16669C9.45093 8.16669 8.14514 8.19751 6.8597 8.2566C5.33205 8.32684 4.07671 9.51419 3.87265 11.0298C3.73948 12.0189 3.62964 13.0326 3.62964 14.0648C3.62964 15.0971 3.73948 16.1108 3.87265 17.0998Z"
        stroke="#424242"
        strokeWidth="1.36111"
      />
      <path
        d="M6.80554 8.16667V5.89815C6.80554 3.64299 8.63371 1.81482 10.8889 1.81482C13.1441 1.81482 14.9722 3.64299 14.9722 5.89815V8.16667"
        stroke="#424242"
        strokeWidth="1.36111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5185 14.0558V14.0648"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8889 14.0558V14.0648"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25928 14.0558V14.0648"
        stroke="#424242"
        strokeWidth="1.81481"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LoockIcon;
